const userProfile = {
  pageTitle: 'Mein Profil',
  toast: {
    success: 'Profil erfolgreich aktualisiert.',
    error: 'Unbekannter Fehler ist aufgetreten.',
  },
  tabs: {
    personalInfo: 'Persönliche Informationen',
    security: 'Sicherheit',
  },
  form: {
    personalDetails: {
      notice: 'Hinweis: Bestimmte Informationen können für andere Personen sichtbar sein, die die Dienste von Moovex nutzen.',
      title: 'Persönliche Daten',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      gender: 'Geschlecht',
      genderOptions: {
        male: 'Männlich',
        female: 'Weiblich',
        default: 'Möchte ich nicht sagen / Sonstiges',
      },
      dateOfBirth: 'Geburtsdatum',
    },
    preferences: {
      title: 'Einstellungen',
      twoFactorAuth: 'Zwei-Faktor-Authentifizierung (2FA)',
      twoFactorAuthWarning: 'requiring a new login.,Durch das Speichern dieser Einstellung werden Sie möglicherweise vom System getrennt und müssen sich erneut anmelden., requiring a new login.',
      twoFactorAuthNotice: 'Die Zwei-Faktor-Authentifizierung (2FA) ist gemäß den Richtlinien erforderlich und kann nicht deaktiviert werden.',
      twoFactorAuthInfo: 'Der Zugriff mit Zwei-Faktor-Authentifizierung (2FA) kann diese Einstellung außer Kraft setzen.',
    },
    userRoles: {
      title: 'Benutzerrollen',
      companyAdmin: 'Firmenadministrator',
      site: 'Bereich',
      role: 'Rolle',
    },
    update: 'Aktualisieren',
  },
  validations: {
    firstName: 'Vorname ist erforderlich',
    lastName: 'Nachname ist erforderlich',
    phone: {
      invalid: 'Telefon ist ungültig',
      required: 'Telefon ist erforderlich',
      length: 'Die Telefonnummer sollte 6 bis 16 Ziffern enthalten',
    },
    email: {
      required: 'E-Mail ist erforderlich',
      email: 'Ungültige E-Mail-Adresse',
    },
  },
};

export default userProfile;
